import { useBreakpoints, breakpointsTailwind } from '@vueuse/core';
import { computed } from 'vue';

export default function useNavigationState(page) {
  const breakpoints = useBreakpoints(breakpointsTailwind);
  const lgAndLarger = breakpoints.greaterOrEqual('lg');

  return {
    isListingsRoute: computed(() => page.url.startsWith('/app/listings/')),
    currentPageComponent: computed(() => page.component),
    lgAndLarger,
  };
}
